"use strict";

export default {
  foerderantragaufgabe: "glyphicon-antrag",
  vertragsaufgabe: "glyphicon-vertrag",
  antragstellerorgaufgabe: "glyphicon-antragsteller",
  auszahlungsaufgabe: "glyphicon-auszahlung",
  sitzungsaufgabe: "glyphicon-tagesordnung"
};
